import axios, {AxiosInstance} from 'axios'
import {config} from '../Global'
import notice from "../components/Notice";

export const instance: AxiosInstance = axios.create({
    withCredentials: true,
    baseURL: config.url.SERVER_API_URL,
});

instance.interceptors.response.use((response) => {
    return response;
    }, (error: any) => {
    if (error.response.status === 404 && !error.response.data?.message) {
        notice ( "error", '404 Not Found', '', 5 )
        return Promise.reject(error.response);
    } else if (error.response.data?.message) {
        let title = error.response.data.message
        let message = ''
        const length = error.response.data.message.length
        if(length > 100) {
            message = title
            title = ''
        }
        notice("error", title, message, 10)
        return Promise.reject(error.response);
    } else if (error.response.data?.errors) {
        let errors = error.response.data.errors
        let message = Object.entries(errors).map(x=>x.join(":")).join("\n");
        notice("error", '', message, 10)
        return Promise.reject(error.response);
    } else {
        return Promise.reject(error.response);
    }
});

export const requests = {
    getFile: (url: string, query = {}) => instance
        .get(url, { responseType: 'blob', params: query }),
        //.then(r => r.data),
    get: (url: string) => instance
        .get(url)
        .then(r => r.data),
    getWithParams: (url: string, query = {}) => instance
        .get(url, { params: query })
        .then(r => r.data),
    post: (url: string, body = {}) => instance
        .post(url, body)
        .then(r => r.data),
    put: (url: string, body = {}) => instance
        .put(url, body)
        .then(r => r.data),
    del: (url: string, query = {}) => instance
        .delete(url, { data: query })
        .then(r => r.data),
    postForm: (url: string, file: any) => {
        let formData = new FormData()
        formData.append('File', file)
        return instance.post(url, formData, {
            headers: {
              'Content-type': 'multipart/form-data',
            },
        }).then(r => r.data)
    },
    postFormMany: (url: string, files: any) => {
        const fd = new FormData()
        files.forEach((file: any) => {
          fd.append('Files', file)
        })
        return instance.post(url, fd, {
            headers: {
              'Content-type': 'multipart/form-data'
            },
        }).then(r => r.data)
    }
}

export default {
  requests
}
